import { Player } from '@lottiefiles/react-lottie-player';
import * as confetti from 'assets/js/animations/confetti-sides.json';

const CampaignSuccess = () => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <div aria-hidden>
                <Player
                    loop
                    autoplay
                    rendererSettings={{ preserveAspectRatio: 'xMidYMin slice' }}
                    src={JSON.stringify(confetti)}
                    className={`pointer-events-none absolute left-0 h-1/3 w-full -translate-y-1/2 sm:top-0 sm:h-full sm:translate-y-0`}
                />
                <div className="flex flex-col items-center justify-center gap-6">
                    <img
                        className={'animate-float w-[150px]'}
                        alt="Illustration"
                        src={`/images/illustrations/superbutter.svg`}
                    />
                    <h3 className="flex flex-col whitespace-pre-wrap text-center text-lg font-medium sm:text-xl">
                        <span>Awesome! One moment while</span>
                        <span>we create your campaign</span>
                    </h3>
                </div>
            </div>

            <span className="sr-only">Awesome! One moment while we create your campaign</span>
        </div>
    );
};

export { CampaignSuccess };
